import { render, staticRenderFns } from "./DownloadFileRow.vue?vue&type=template&id=20e13a26&"
import script from "./DownloadFileRow.vue?vue&type=script&lang=js&"
export * from "./DownloadFileRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports